module.exports = __webpack_public_path__ + "img/sec2.edc58d73.png";